import { render, staticRenderFns } from "./portfolioCompanies.vue?vue&type=template&id=7203fa0c&scoped=true&"
import script from "./portfolioCompanies.vue?vue&type=script&lang=js&"
export * from "./portfolioCompanies.vue?vue&type=script&lang=js&"
import style0 from "./portfolioCompanies.vue?vue&type=style&index=0&id=7203fa0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203fa0c",
  null
  
)

export default component.exports